import { useState } from "react";
import { CheckCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { IEbayListingBatchItem } from "../../../models/bulkListings/BulkListing";
import PopOutBox from "../../shared/PopOutBox";
import RecentlyListedTypeCell from "./RecentlyListedTypeCell";
import UnlistedReadyStatus from "../unlistedTable/UnlistedReadyStatus";
import Modal from "../../../layouts/Modal";


export default function RecentlyListedErrorCell({ batchItem, showExtraInfo = true }: { batchItem: IEbayListingBatchItem, showExtraInfo?: boolean }) {
  const [modalOpen, setModalOpen] = useState(false);

  if (!batchItem.errorMessage) {
    return (
      <div className="flex flex-col gap-y-4 items-center justify-center">
        <CheckCircleIcon className="h-6 w-6 text-green-500" />
        <RecentlyListedTypeCell type={batchItem.type} />
      </div>
    )
  }

  const errorIcon = batchItem.isListed
    ? <ExclamationTriangleIcon className="h-6 w-6 text-yellow-500 cursor-pointer" />
    : <ExclamationTriangleIcon className="h-6 w-6 text-red-500 cursor-pointer" />;

  return (
    <>
      <div className="flex flex-col gap-y-4 items-center justify-center">
        <div className="hover:scale-110 z-50" onClick={(e) => { e.stopPropagation(); setModalOpen(true); }}>
          <PopOutBox
            position="left"
            classes="max-w-3xl max-w-[60vw] max-h-[50vh] overflow-y-auto"
            icon={errorIcon}
          >
            <div className="p-2">
              <p className="text-sm font-medium">eBay Error - Click to see full error</p>
              <pre>{batchItem.errorMessage}</pre>
            </div>
          </PopOutBox>
        </div>
        {showExtraInfo && (
          <>
            <RecentlyListedTypeCell type={batchItem.type} />
            {!batchItem.isListed && <UnlistedReadyStatus part={batchItem.partData} />}
          </>
        )}

      </div>
      <Modal open={modalOpen} setOpen={setModalOpen} width="max-w-[70vw]">
        <div className="p-4">
          <h3 className="text-lg font-semibold mb-4">eBay Error</h3>
          <div className="max-h-[70vh] overflow-y-auto">
            <pre className="overflow-x-auto break-words text-sm bg-gray-50 p-4 rounded border">{batchItem.errorMessage}</pre>
          </div>
        </div>
      </Modal>
    </>
  )
}